
<script>
	import { afterUpdate } from 'svelte';
	
	function AceitarCookies(){
		localStorage.setItem("conditionsCookies", true);
		ValidarCookies();
	}
	
	function ValidarCookies(){
		let conditionsCookies   = JSON.parse(localStorage.getItem("conditionsCookies"));
		let popupLGPD           = document.querySelector('.popup-lgpd');

		if(conditionsCookies){
			popupLGPD.classList.remove("popup-lgpd--open");
		}else{            
			popupLGPD.classList.add("popup-lgpd--open");
		}
	}

	afterUpdate(() => { 
		ValidarCookies();
	});    
</script>

<div class="popup-lgpd popup-lgpd--open">
	<p class="popup-lgpd__link">Utilizamos cookies para melhorar a sua experiência com a gente. Você pode gerenciar e bloquear os cookies através das configurações de seu navegador ou software. O bloqueio de cookies poderá prejudicar o funcionamento de algumas partes de nosso site. Ao continuar navegando, você concorda com estas condições.</p>
	<button class="btn btn-primary popup-lgpd__btn" on:click={AceitarCookies} onClick="return false;">Concordar e Fechar</button>
</div>

<style type="text/sass">
.popup-lgpd
	background: #fff
	bottom: 25px
	box-shadow: 0 0 10px #aaa
	border-radius: 12px
	left: 10px
	right: 10px
	padding: 20px
	margin: 0 auto
	max-width: 1200px
	position: fixed
	z-index: 9999
	visibility: hidden
	transition: .3s ease-in-out
	-webkit-transform: translateY(300px)
	-ms-transform: translateY(300px)
	transform: translateY(300px)

.popup-lgpd--open
	visibility: visible
	transition: .1s ease-in-out
	-webkit-transform: translate(0)
	-ms-transform: translate(0)
	transform: translate(0)

.popup-lgpd__btn
	cursor: pointer
	font-size: 16px
	padding: 10px 20px
	text-align: center
	width: 100%
	white-space: nowrap
	min-width: unset

@media screen and (min-width: 767px)
	.popup-lgpd
		display: flex
		align-items: center    
	.popup-lgpd p
		margin: 0
		font-size: 16px
	.popup-lgpd__btn
		margin-left: 15px
		width: unset
</style>